import { captureMessage, withScope } from "@sentry/react";
import { Extras } from "@sentry/types";

export const logToSentry = (message: string, extras?: Extras) => {
    // oxlint-disable-next-line no-console
    console.warn({ message, extras });

    withScope((scope) => {
        if (extras) scope.setExtras(extras);
        captureMessage(message);
    });
};
